import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store configuration for trait categories
const traitCategoriesBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/trait_categories",
  name: "TraitCategoriesStoreRefactor",
  objectName: "Eigenschap Categorie", // Auto-generates CRUD success messages
  enableCache: true, // Enable caching since categories change infrequently
  actionCableChannel: null, // No real-time updates needed for now
  infiniteLoading: false, // Simple list, no pagination needed
});

export const useTraitCategoriesStoreRefactor = defineStore(
  "traitCategoriesRefactor",
  {
    ...traitCategoriesBaseStore,

    getters: {
      ...traitCategoriesBaseStore.getters,

      /**
       * Get all trait categories (maps to state.data for compatibility)
       */
      categories: (state) => {
        return state.data || [];
      },

      /**
       * Get trait category by ID
       */
      getCategoryById: (state) => (id) => {
        return state.data.find((category) => category.id == id);
      },

      /**
       * Get trait categories formatted for select options
       */
      categoryOptions: (state) => {
        return (state.data || []).map((category) => ({
          title: category.name, // Use name instead of label
          value: category.id,
          subtitle: category.name,
        }));
      },

      /**
       * Get categories as simple select items (for forms)
       */
      selectItems: (state) => {
        return (state.data || []).map((category) => ({
          label: category.name, // Use name instead of label
          value: category.id,
          name: category.name,
        }));
      },
    },

    actions: {
      ...traitCategoriesBaseStore.actions,

      // All CRUD methods are fully inherited from base store
      // Auto-generated messages use "Eigenschap Categorie" from objectName
    },
  },
);
